(() => {
  const name='SmartBfcmPdpCompact';
  if(window[name]){window[name].init();return;}
  const eligible=new Set(['42269880025167','46804334379087','46830633058383','67811092529231','67823846817871','67823850586191']);
  const roots=new Set();
  let clock;
  const tick=()=>{
    roots.forEach(root=>{
      if(!root.isConnected){roots.delete(root);return;}
      const remaining=Math.max(0,Math.ceil((Date.parse(root.dataset.endAt)-Date.now())/1000));
      if(!remaining){root.hidden=true;roots.delete(root);return;}
      const values=[Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];
      ['days','hours','minutes','seconds'].forEach((unit,index)=>{root.querySelector('[data-bf-pdp-'+unit+']').textContent=String(values[index]).padStart(2,'0');});
    });
    if(!roots.size){clearInterval(clock);clock=null;}
  };
  const init=()=>{
    document.querySelectorAll('[data-bf-pdp-campaign]').forEach(root=>{
      if(root.dataset.initialized)return;root.dataset.initialized='true';roots.add(root);
      const scope=root.closest('[data-section-type="product"]')||root.closest('article')||document;
      const form=scope.querySelector('form[action*="/cart/add"]');
      const selected=()=>form?.querySelector('[name="id"]')?.value||root.dataset.variant;
      const sync=()=>{const gift=eligible.has(String(selected()));root.querySelector('[data-bf-pdp-gift]').hidden=!gift;root.classList.toggle('bf-pdp--gift',gift);root.dataset.selectedVariant=String(selected());};
      let delayed;
      const schedule=()=>{requestAnimationFrame(sync);clearTimeout(delayed);delayed=setTimeout(sync,80);};
      scope.addEventListener('change',schedule);
      scope.addEventListener('click',event=>{if(event.target.closest('[data-smart-variant-pill],[data-option-selector]'))schedule();});
      document.addEventListener('variant:change',schedule);
      document.addEventListener('variant:changed',schedule);
      window.addEventListener('popstate',schedule);
      sync();
    });
    tick();if(roots.size&&!clock)clock=setInterval(()=>{if(!document.hidden)tick();},1000);
  };
  window[name]={init};
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)tick();});
  document.addEventListener('shopify:section:load',init);
  init();
})();
